import { render, staticRenderFns } from "./ListWidget.vue?vue&type=template&id=65a02a8c&"
import script from "./ListWidget.vue?vue&type=script&lang=js&"
export * from "./ListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports